import React, { useEffect, useState, useRef } from "react";
import GlobalVar from "../config/globalVar";
import {
  FormControl,
  Box,
  InputLabel,
  Input,
  List,
  ListItem,
  ListItemText,
  Chip,
  FormHelperText,
} from "@mui/material";
import { searchSelect, getAllPurposes } from "../services/httpCalls";

export default function SearchSelect(props) {
  const [value, setValue] = useState("");
  const [active, setActive] = useState(false);
  const [list, setList] = useState([]);
  const [type, setType] = useState("")
  const boxRef = useRef();
  const shouldSkipSpecialCharCheck =
    typeof window !== "undefined" &&
    window.location?.pathname &&
    ["viewvendor", "createtransaction", "update/"].some((segment) =>
      window.location.pathname.toLowerCase().includes(segment)
    );
  const ENDPOINTS = {
    opsMemberAssigned: "user/v1/search?",
    vendorName: "v1/vendor/search?",
    caAssignedName: "v1/caFirm/search?",
    orgSelect: "organisation/v1/search?",
    vendorSelect: "v1/vendor/search?",
    bankname : 'v1/bank/search?'
  };
  const [error, setError] = useState('')

  useEffect(() => {
    if (props.value) {
      setValue(props.value);
      setType(props.type)
    }
  }, []);

  const changeList = async (e) => {
    setValue(e)
    if (!shouldSkipSpecialCharCheck && hasSpecialCharacters(e) && props.name !== "orgSelect") {
      setError('Special characters are not allowed');   
     } else {
    setError('');
    if (props.id === "currencyCode") {
      let list_ = [];
      GlobalVar.currencyCodes.forEach((code) => {
        let e_ = e.toUpperCase();
        if (code.includes(e_)) {
          list_.push(code);
        }
      });
      setList(list_);
      setActive(true);
    } else if (props.id === "purposeCode") {
      if(props.productType !== "INWARD") {
        if (e.length > 1) {
          setType("")
          await getAllPurposes(e).then((res) => {
            setList(res);
            setActive(true);
          });
        } 
    } else {
      setList(GlobalVar.purposeCodesInward);
      setActive(true)
    } 
  }
    else {
      if (e.trim().length > 1) {
        await searchSelect(e, ENDPOINTS[props.name]).then((res) => {
          if(props.productType === "OUTWARD") {
            let orgs = res.filter(orgs => orgs.isOptOutward)
            setList(orgs)
          } else {
            setList(res);
          }
          setActive(true);
        });
      }
    }
    }
    
  }


  const selectionVal = (e) => {
    if (props.id === "currencyCode") {
      if (e) {
        setValue(e);
      }
    } else if (props.id === "purposeCode") {
      if(props.productType !== "INWARD") {
        if (e) {
          setValue(
            e.paymentPurposeCodeAsPerRBI +
              " - " +
              e.paymentPurposeDescriptionAsPerRBI
          );
          setActive(false);
          setType(e.transactionType)
          if(props.setType_){
            props.setType_(e.transactionType)
          }
        }
      } else {
        setValue(
          e.label
        )
        setActive(false);
      }

    } else {
      if (e.name) {
        setValue(e.name);
      }
    }
    props.selectSearchData(e, props.name, props.id);
    setActive(false);
  };
  useEffect(() => {
    window.onclick = (event) => {
      if (
        event.target.contains(boxRef.current) &&
        event.target !== boxRef.current
      ) {
        setActive(false);
      } else {
        setActive(false);
      }
    };
  }, []);

  const primaryList = (elem) => {
  
    if(props.productType !== "INWARD"){ 
      return props.id === "currencyCode"
      ? elem
      : props.id === "purposeCode"
      ? elem.paymentPurposeCodeAsPerRBI +
        " - " +
        elem.paymentPurposeDescriptionAsPerRBI
      : elem.name
    } else {
      return (elem.label)
    } 
}

const hasSpecialCharacters = (value) => {
  const specialCharRegex = /[^a-zA-Z0-9\s]/g;
  return specialCharRegex.test(value);
};

  return (
    <Box ref={boxRef}>
      <FormControl
        variant="standard"
        sx={{
          width: "300px",
          display: "block",
          marginTop: ".5rem",
          position: "relative",
        }}
        disabled={props?.disabled ? props.disabled : false}
        error={!!error}
      >
        <InputLabel className="label_select" htmlFor={props.id}>{props.label} {props.id === "purposeCode" && type ? <Chip label={type} color="primary" /> : ""}</InputLabel>
        <Input
          id={props.id}
          inputProps={{ maxLength: 100 }}
          sx={{ width: "100%" }}
          autoComplete={"off"}
          value={value}
          onChange={(e) => changeList(e.target.value)}
          required={props.required === false ? false : true}
        />
        <Box>
          <List
            sx={{
              width: "100%",
              maxWidth: 360,
              position: "absolute",
              bgcolor: "#fff",
              maxHeight: "300px",
              overflowY: "auto",
              border: "1px solid #a2a2a2",
              zIndex: "9",
              display: active ? "block" : "none",
            }}
          >
            {list.length ? (
              list.map((elem, i) => (
                <ListItem
                  key={i}
                  disableGutters
                  sx={{ cursor: "pointer", padding: ".5rem" }}
                  onClick={(e) => selectionVal(elem)}
                >
                  <ListItemText
                    primary={primaryList(elem)}
                  />
                </ListItem>
              ))
            ) : (
              <ListItem
                disableGutters
                sx={{ cursor: "pointer", padding: ".5rem" }}
              >
                <ListItemText
                  primary={"No Matching Results"}
                  onClick={() => {
                    setActive(false);
                  }}
                />
              </ListItem>
            )}
          </List>
        </Box>
        {error && <FormHelperText>{error}</FormHelperText>}
      </FormControl>
    </Box>
  );
}
